import { useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'

import {
  BROWSER_TAB_LOADING_TEXT_KEY,
  createTabTitle,
} from '../usePageBrowserTabTitle'

import {
  BROWSER_PAGE_SEO_TITLE_FALLBACK_TIMEOUT,
  META_DESCRIPTION_NAME,
} from './useSeoInitialValues.constants'

// Called by InitProvider itself, so the init data comes in as an argument
// instead of through InitDataContext (the provider is above its own context).
export function useSeoInitialValues(initData) {
  const { t } = useTranslation()

  const timeoutRef = useRef(null)

  const metaDescription = initData?.seo?.meta_description
  const seoTitle = initData?.seo?.title

  useEffect(() => {
    if (metaDescription) {
      const existingMetaDescription = document.head.querySelector(
        `meta[name="${META_DESCRIPTION_NAME}"]`
      )

      if (existingMetaDescription) {
        existingMetaDescription.setAttribute('content', metaDescription)
      } else {
        const metaElement = document.createElement('meta')

        metaElement.setAttribute('name', META_DESCRIPTION_NAME)
        metaElement.setAttribute('content', metaDescription)
        document.head.appendChild(metaElement)
      }
    }
  }, [metaDescription])

  const loadingBrowserTabTitle = createTabTitle({
    title: `${t(BROWSER_TAB_LOADING_TEXT_KEY)}...`,
  })

  useEffect(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current)
    }

    timeoutRef.current = setTimeout(() => {
      if (document.title === loadingBrowserTabTitle && seoTitle) {
        document.title = seoTitle
      }
    }, BROWSER_PAGE_SEO_TITLE_FALLBACK_TIMEOUT)

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current)
        timeoutRef.current = null
      }
    }
  }, [initData])
}
